// 所有 API 地址
'use strict';
import UserStore from 'stores/UserStore';
import {browserHistory} from 'react-router';

const host = 'https://api.xiaodiqiu.cn/api/';
const webhost = 'http://xiaodiqiu.cn/';
const webHome = 'http://xiaodiqiu.cn/medias';
const userAgent = navigator.userAgent;
const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const urlHeader = new Headers();
urlHeader.append('content-type', 'application/x-www-form-urlencoded');
const jsonHeader = new Headers();
jsonHeader.append('content-type', 'application/json');
const fileHeader = new Headers();
fileHeader.append('content-type', 'multipart/form-data');
const isWechat = /micromessenger/ig.test(navigator.userAgent);
const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);

const acquireWechatLoginUrl = () => {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf26269dff8baf82c&redirect_uri=${encodeURIComponent(`https://api.xiaodiqiu.cn/api/v2/login/wechat?url=${location.href}`)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
}

const refreshToken = () => {
   if(isWechat) {
     location.href = acquireWechatLoginUrl();
   } else {
     browserHistory.push('/login');
   }
}

const API = {
    get isWechat() {
        return /micromessenger/ig.test(navigator.userAgent);
    },
    get isMobile() {
        return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    get isAndroid() {
        return isAndroid;
    },
    get isiOS() {
        return isiOS;
    },
    get accessToken() {
        return UserStore.getState().accessToken;
    },
    get userId() {
        return UserStore.getState().user_id;
    },
    get checkToken() {
        if(!UserStore.getState().accessToken) {
            if(isWechat){
                location.href = acquireWechatLoginUrl() 
            } else{
                browserHistory.push('/login');
            }
            return false;
        }else{
            return true;
        }
    },
    appid: 'wxf26269dff8baf82c',

    // postParam
    urlHeader: urlHeader,
    jsonHeader: jsonHeader,
    fileHeader: fileHeader,
    // login
    postLogin: `${host}v1/user/login`,
    postRegister: `${host}v1/user/register`,
    postForget: `${host}v1/user/forget`,
    redirectWechatLogin : acquireWechatLoginUrl(), 
    getAccessToken: `${host}v2/accesstoken`,
    postAccessTokenExamine: `${host}v2/auth`,
    getCaptcha:`${host}v1/authcode`,
    // Destinations
    get getDestinations() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/destination/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/destination/:id?`;
        } 
    },
    // google map key
    get getMapAPIKey() {
        return 'AIzaSyARt_sryUct9Av0H2i-Ac50T_dnrKpCvSE';
    },
    // share
    get getWebsiteHref() {
        return `${webhost}`;
    },
    get getWebsiteMediasHref() {
        return `${webhost}medias`;
    },
    get getWebsiteMediaHref() {
        return `${webhost}media/`;
    },
    get getWebsiteAlbumsHref() {
        return `${webhost}albums`;
    },
    get getWebsiteAlbumHref() {
        return `${webhost}album/`;
    },
    get getWebsiteOpportunitiesHref() {
        return `${webhost}opportunities`;
    },
    get getWebsiteOpportunityHref() {
        return `${webhost}opportunity/`;
    },
    get getWebsitePorfileHref() {
        return `${webhost}profile`;
    },
    get getWebsiteUserHref() {
        return `${webhost}user/`;
    },
    // wechat js-sdk config
    get getWechatConfig() {
        return `${host}v1/wechat/jssdk/config?url=${encodeURIComponent(location.href)}`;
    },
    get getHomeWechatConfig() {
        return `${host}v1/wechat/jssdk/config?url=${encodeURIComponent(webHome)}`;
    },
    // media
    get getMediaList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/media?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/media?`;
        }
    },
    get getRecommendMediaList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/media/:id/recommend?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/media/:id/recommend?`;
        }
    },
    get getMediaDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/media/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/media/:id?`;
        }
    },
    get deleteMedia(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media/delete?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get postMedia() {
        return `${host}v1/auth/media`;
    },
    get postCategory() {
        return `${host}v1/auth/category`;
    },
    get postMediaPay() {
        return `${host}v1/auth/media/:id/pay?h5=${!isWechat}`;
    },
    get postProductPay() {
        return `${host}v1/auth/product/:id/pay?h5=${!isWechat}`;
    },
    get postAlbumPay() {
        return `${host}v1/auth/album/:id/pay?h5=${!isWechat}`;
    },
    get postMediaWxShare() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media/share?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // Business
    get getBusinessList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/user/:id/businesses?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/user/:id/businesses?`;
        }
    },
    get getBusinessDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/business/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/business/:id`;
        }
    },
    get postBusiness() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/business?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getBusinessArticles() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/business/:id/articles?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/business/:id/articles?`;
        }
    },
    get getAgentInviteUrl() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/agent/invite?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getBusinessCheckOAuth() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/business/check?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/business/check`;
        }
    },
    get getAgentCheckOAuth() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/agent/check?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/agent/check`;
        }
    },
    // Feature
    get getFeatureList(){
        if(UserStore.getState().accessToken) {
        return `${host}v1/feature?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/feature?`;
        }
    },
    // Slide
    get getSlideList(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/slide?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/slide?`;
        }
    },
    // Link
    get postLink(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/link?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // Teams
    get getTeamList(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/team?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/team?`;
        }
    },
    get getTeamStartList(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/team/start?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/team/start?`;
        }
    },
    // Product
    get getProductList(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/product?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/product?`;
        }
    },
    get getProductDetail(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/product/:id?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/product/:id?`;
        }
    },
    get getProductComments(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/product/:id/comment?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/product/:id/comment?`;
        }
    },
    get getProductTeams(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/product/:id/team?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/product/:id/team?`;
        }
    },
    get getHistoryTeamss(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/product/:id/team/history?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/product/:id/team/history?`;
        }
    },
    get postProduct() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/product?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get postUpdateProduct() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/product/:id/update?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get postCollectProduct() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/product/:id/want?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get postUncollectProduct() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/product/:id/unwant?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // Opportuniry
    get getOpportunityList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/opportunity/list?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/opportunity/list?`;
        }
    },
    get getOpportunityDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/opportunity/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/opportunity/:id?`;
        }
    },
    get getOpportunityRegister() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/opportunity/:id/register?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/opportunity/:id/register?`;
        }
    },
    get getOpportunitySelecter(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/opportunity/:id/selecter?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/opportunity/:id/selecter?`;
        }
    },
    get postOpportunityPay(){
        if(UserStore.getState().accessToken){
            return `${host}v1/auth/wechat/order?accessToken=${UserStore.getState().accessToken}`;
        }else{
            refreshToken();
            return;
        }
    },
    get getOpportunityReferral(){
        if(UserStore.getState().accessToken){
            return `${host}v1/opportunity/:id/referral?accessToken=${UserStore.getState().accessToken}`;
        }else{
            return `${host}v1/opportunity/:id/referral?`;
        }
    },
    get postOpportunityReferral(){
        if(UserStore.getState().accessToken){
            return `${host}v1/auth/opportunity/:id/referral?accessToken=${UserStore.getState().accessToken}`;
        }else{
            refreshToken();
            return;
        }
    }, 
    // Category
    get getCategoryDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/category/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/category/:id?`;
        }
    },
    get getCategoryList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/category?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/category?`;
        }
    },
    // 地址
    get getContinentDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/continent/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/continent/:id?`;
        }
    },
    get getContinentList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/continent?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/continent?`;
        }
    },
    get postContinent() {
        return `${host}v1/auth/continent`;
    },
    get getCountryDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/country/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/country/:id?`;
        }
    },
    get getCountryList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/country?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/country?`;
        }
    },
    get postCountry() {
        return `${host}v1/auth/country`;
    },
    get getStateDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/state/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/state/:id?`;
        }
    },
    get getStateList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/state?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/state?`;
        }
    },
    get postState() {
        return `${host}v1/auth/state`;
    },
    get getCityDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/city/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/city/:id?`;
        }
    },
    get getCityList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/city?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/city?`;
        }
    },
    get postCity() {
        return `${host}v1/auth/city`;
    },
    get getLocationSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/location/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getPlace() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/place/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // 图片上传
    get wechatMediaUpload() {
        return `${host}v1/wechat/media/upload`;
    },
    get imageUpload() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/image/upload?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get wechatImageUpload() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/wechat/media/upload?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        } 
    },
    // 评论
    get postComment() {
        return `${host}v1/auth/comment`;
    },
    get getCommentById() {
        return `${host}v1/comment/:id?accessToken=${UserStore.getState().accessToken}`;
    },
    get getComment() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/comment?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/comment?`;
        }
    },
    get getUserComments() {
        if(UserStore.getState().accessToken) {
            return `${host}/v1/auth/comment?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;  
        }
    },
    // 专辑
    get postAlbum() {
        return `${host}v1/auth/album`;
    },
    get postUpdateAlbum() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album/:id/update?accessToken=${UserStore.getState().accessToken}`;
        }else{
            refreshToken();
            return;
        }
    },
    get postUpdateBAlbum() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album/:id/b/update?accessToken=${UserStore.getState().accessToken}`;
        }else{
            refreshToken();
            return;
        }
    },
    get postCollectAlbum() {
        return `${host}v1/auth/album/:id/collect`;
    },
    get postUncollectAlbum() {
        return `${host}v1/auth/album/:id/uncollect`;
    },
    get getAlbumDetail() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/album/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/album/:id?`;
        }
    },
    get deleteAlbum(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album/delete?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getAlbumMedia() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/album/:id/media?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/album/:id/media?`;
        }
    },
    get getAlbumArticleMedia() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/article/:id/media?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/article/:id/media?`;
        }
    },
    get getAlbumList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/album?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/album?`;
        }
    },
    get getRecommendAlbumList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/album/:id/recommend?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/album/:id/recommend?`;
        }
    },
    get postAlbumAddMedia() {
        return `${host}v1/auth/album/:id/media`;
    },
    // porder
    get getPorderList(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/porder?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getPorderDetail(){
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/porder/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // user
    get getUserAlbumCollect() {  //  用户收藏的专辑
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album/collect?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserAlbum() {    // 用户发布的专辑
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getPublishAlbumByUser() {   // 其他用户发布的专辑
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/album?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;  
        }
    },
    get getCollectAlbumByUser() {   // 其他用户收藏的专辑
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/album/collect?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserMedia() {    // 用户发布的 media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getPublishMediaByUser() {   //其他用户发布的media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/media?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserMediaCollect() { // 用户收藏的 media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media/collect?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getCollectMediaByUser() {   //其他用户收藏的media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/media/collect?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserMediaPaid() {    // 用户已付费的 media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media/pay?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getPaidMediaByUser() {  // 其他用户付费的 media
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/media/pay?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserFollowing() {    // 用户关注的人
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/following?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserFollower() {     // 用户的粉丝
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/follower?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserWantList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/want?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserLinkList() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/link?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getFollowingByUser() {  // 其他用户关注的人
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/following?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getFollowerByUser() {   // 其他用户的粉丝
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id/follower?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get postUserFollow() {  // 关注某人
        return `${host}v1/auth/user/:id/follow`;
    },
    get postUserUnfollow() {    // 取消关注某人
        return `${host}v1/auth/user/:id/unfollow`;
    },
    get postUserUpdate() {  // 更新用户个人信息
        return `${host}v1/auth/user`;
    },
    get getUser() { // 获取当前用户信息
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserInfo() { // 根据id获取任意用户信息
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/user/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getAgentInfo() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/agent?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getOtherAgentInfo() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/agent/:id?accessToken=${UserStore.getState().accessToken}`;
        } else {
            return `${host}v1/agent/:id`;
        }
    },
    get postAgent() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/agent?accessToken=${UserStore.getState().accessToken}`; 
        } else {
            refreshToken();
            return;
        }
    },
    get getAgentArticles() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/agent/:id/articles?accessToken=${UserStore.getState().accessToken}`
        } else {
            return `${host}v1/agent/:id/articles?`
        }
    },
    get postAvatar() { // 头像上传
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/avatar?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    // search
    get getProductSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/product/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getAlbumSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/album/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getMediaSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/media/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getFeatureSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/feature/search?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    },
    get getUserSearch() {
        if(UserStore.getState().accessToken) {
            return `${host}v1/auth/search/user?accessToken=${UserStore.getState().accessToken}`;
        } else {
            refreshToken();
            return;
        }
    }
};

export default API;


// WEBPACK FOOTER //
// ./src/sources/API.js